import React, { useCallback } from 'react';
import { View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import { useTranslation } from '@/hooks/useTranslation';
import { useModalStore } from '@/store';
import useRequireAuth from '@/hooks/useRequireAuth';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import Button from '@/components/Buttons/Button';
import { getCatalogPalette } from '@/components/Catalog/catalogPalette';

export default function TasksEmptyState({ onBrowseTemplates }) {
  const { theme } = useTheme();
  const { t } = useTranslation();
  const { openModal } = useModalStore(s => s.actions);
  const requireAuth = useRequireAuth();
  const palette = getCatalogPalette(theme);
  const handleCreate = useCallback(() => requireAuth(() => openModal('CreateTaskModal'), {
    source: 'tasks_empty_create_task',
    title: 'Sign in to create a Task',
    subtitle: 'Scheduled tasks run on your account so we know when (and for whom) to fire them.',
    icon: 'calendar-clock',
  }), [openModal, requireAuth]);

  return (
    <View style={{ padding: 24, borderRadius: 18, borderWidth: 1, borderColor: palette.border, backgroundColor: palette.surface, alignItems: 'center', gap: 12 }}>
      <View style={{ width: 44, height: 44, borderRadius: 12, backgroundColor: palette.preview, alignItems: 'center', justifyContent: 'center' }}>
        <Icon name="calendar-clock" size={20} color={palette.icon} />
      </View>
      <Text size="l" weight="semibold" style={{ textAlign: 'center' }}>{t('pages.tasks.emptyTitle')}</Text>
      <Text size="s" color="secondary" style={{ textAlign: 'center', lineHeight: 21, maxWidth: 440 }}>{t('pages.tasks.emptyDescription')}</Text>
      <View style={{ flexDirection: 'row', justifyContent: 'center', flexWrap: 'wrap', gap: 8, marginTop: 4 }}>
        {onBrowseTemplates && <Button text={t('pages.tasks.browseTemplates')} onPress={onBrowseTemplates} variant="secondary" size="medium" />}
        <Button text={t('pages.tasks.newTask')} onPress={handleCreate} prependIcon="plus" variant="secondary" size="medium"
          style={{ backgroundColor: palette.ink }} textStyle={{ color: palette.onInk }} iconColor={palette.onInk} hoverBackgroundColor={palette.ink} />
      </View>
    </View>
  );
}
